import { BrandType } from '../generated/graphql';

export const getBrandLabel = (type: BrandType | string) => {
  switch (type) {
    case BrandType.Beta: return 'Beta';
    case BrandType.Tranquiapp: return 'Tranqui';
    case BrandType.Jcap: return 'JCAP Jefferson Capital Systems, LLC';
    default: return type;
  }
};
